import {
  Button,
  Col,
  DatePicker,
  Form,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Typography,
} from 'antd';
import React, { useEffect, useState } from 'react';
import IntlMessage from '../../../components/IntlMessage';
import useTime from '../../../hooks/useTime';
import orderApi from '../../../api/order';
import Status from '../../../components/Status';
import { formatCurrency, formatNumber } from '../../../helpers/helpers';
import dayjs from 'dayjs';
import _, { debounce } from 'lodash';
import { SearchOutlined } from '@ant-design/icons';
import FilterBar from '../../../components/FilterBar';
import { OrderStatus, PayStatus, pay_method } from '../../../utils/constant';
import reportApi from '../../../api/report';
import { isMobile } from 'react-device-detect';
import ModalInfo from './ModalInfo';
import ModalInfoDetail from './ModalInfoDetail';

const { Text } = Typography;

const ModalOrder = ({ open, onClose, item, filter_value }) => {
  const [form] = Form.useForm();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const { convertToAnyTimezone, formatAsISOString } = useTime();
  const [filter, setFilter] = useState({
    from_date: filter_value.from_date,
    to_date: filter_value.to_date,
    page: 1,
    limit: 10,
  });
  const [condition, setCondition] = useState({});
  const [total, setTotal] = useState(null);
  const [totalPending, setTotalPending] = useState(null);
  const [totalPaid, setTotalPaid] = useState(null);
  const [totalCancelled, setTotalCancelled] = useState(null);
  const [reload, setReload] = useState(false);
  const [mode, setMode] = useState('date');
  const [ItemInfo, setItemInfo] = useState({});
  const [modalInfo, setModalInfo] = useState(false);
  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObjectDeep(
        filter?.filter_name,
        filter?.filter_value
      );
      setCondition(newCondition);
    }
  }, [filter]);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        await reportApi
          .getCashierReportDetail(item?.userOperator?.id, filter)
          .then((res) => {
            setItems(res.data);
            setTotal(res?.total);
            setTotalPending(res?.extra?.total_pending);
            setTotalPaid(res?.extra?.total_paid);
            setTotalCancelled(res?.extra?.total_cancelled);
            setLoading(false);
          });
      } catch (error) {
        setLoading(false);
        console.error(error);
      }
    }

    fetchData();
  }, [filter, reload]);

  const onFilter = debounce(async (value, title, type) => {
    if (type === 'search') {
      setFilter((filter) => {
        return { ...filter, keyword: value, page: 1 };
      });
    } else {
      const filter_obj = { ...condition, [title]: value };
      let filter_name = [];
      let filter_value = [];
      for (var key in filter_obj) {
        if (filter_obj[key]) {
          filter_name.push(key);
          filter_value.push(filter_obj[key]);
        }
      }
      setFilter((filter) => {
        return {
          ...filter,
          filter_name: filter_name,
          filter_value: filter_value,
        };
      });
    }
  }, 300);

  const getOrder = (order) => {
    if (order === 'ascend') return 'ASC';
    if (order === 'descend') return 'DESC';
    return 'DESC';
  };

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] }
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : 'id',
    });
  };

  const onSearchDate = () => {
    form.validateFields().then((values) => {
      setFilter((filter) => {
        return {
          ...filter,
          from_date:
            mode === 'date'
              ? values.from_date?.toISOString()
              : values.from_date?.startOf(mode)?.toISOString(),
          to_date:
            mode === 'date'
              ? values.to_date?.toISOString()
              : values.from_date?.endOf(mode)?.toISOString(),
        };
      });
    });
  };

  const onChangeMode = (value) => {
    setMode(value);
    form.setFieldsValue({
      from_date: value === 'date' ? dayjs().startOf('M') : dayjs(),
      to_date: value === 'date' ? dayjs().endOf('M') : dayjs(),
    });
  };
  const onOpenModalInfo = (record) => {
    setModalInfo(true);
    setItemInfo(record);
  };

  const onCloseModalInfo = (record) => {
    setModalInfo(false);
  };
  const columns = [
    // {
    //   key: 'agent_name',
    //   title: <IntlMessage id="global.name" />,
    //   width: isMobile ? 100 : 300,
    //   fixed: 'left',
    //   render: (text, record) => {
    //     return (
    //       <Space direction="vertical" size={2}>
    //         <span style={{ color: '#1677ff' }}>
    //           {record?.first_name + ' ' + record?.last_name}
    //         </span>
    //         {Number(record?.total_not_paid_tickets) > 0 && (
    //           <Text style={{ color: 'red', padding: '4px 0px' }}>
    //             {formatCurrency(record?.total_not_paid_tickets)}
    //           </Text>
    //         )}
    //       </Space>
    //     );
    //   },
    // },
    {
      key: 'closing',
      title: <IntlMessage id="global.closing" />,
      render: (text, record) => {
        const date = dayjs(record?.close_date);
        return (
          <Space direction="vertical">
            <Text>{date.format('DD/MM/YYYY')}</Text>
            <Text>{date.format('HH:mm')}</Text>
          </Space>
        );
      },
    },
    {
      key: 'total',
      title: 'Total',
      render: (text, record) => {
        return formatCurrency(
          Number(record?.total_paid_tickets) +
            Number(record?.data_luggage_summary?.global_total?.total || 0)
        );
      },
    },
    {
      key: 'first_date_time',
      title: <IntlMessage id="global.first_sale" />,
      render: (text, record) => {
        const date = dayjs(record?.first_date);
        return (
          <Space direction="vertical">
            <Text>{record?.order_first_sale?.order_no}</Text>
            <Text>{date.format('DD/MM/YYYY')}</Text>
            <Text>{date.format('HH:mm')}</Text>
          </Space>
        );
      },
    },
    {
      key: 'last_date_time',
      title: <IntlMessage id="global.last_sale" />,
      render: (text, record) => {
        const date = dayjs(record?.last_date);
        return (
          <Space direction="vertical">
            <Text>{record?.order_last_sale?.order_no}</Text>
            <Text>{date.format('DD/MM/YYYY')}</Text>
            <Text>{date.format('HH:mm')}</Text>
          </Space>
        );
      },
    },
    // {
    //   key: 'total_paid',
    //   title: '#Paid',
    //   render: (text, record) => {
    //     return formatNumber(record?.paid_tickets);
    //   },
    // },
    // {
    //   key: 'not_paid_tickets',
    //   title: '#Not paid',
    //   render: (text, record) => {
    //     return formatNumber(record?.not_paid_tickets);
    //   },
    // },
    // {
    //   key: 'cancelled_tickets',
    //   title: 'Cancelled',
    //   render: (text, record) => {
    //     return (
    //       <Space direction="vertical">
    //         <Text>{record?.cancelled_tickets}</Text>
    //         {record?.total_cancelled_tickets > 0 && (
    //           <Text>{formatCurrency(record?.total_cancelled_tickets)}</Text>
    //         )}
    //       </Space>
    //     );
    //   },
    // },

    {
      key: 'btn',
      title: '',
      render: (text, record) => {
        return (
          <Button
            shape="round"
            size="small"
            type="primary"
            onClick={() => onOpenModalInfo(record)}>
            <IntlMessage id="global.detail" />
          </Button>
        );
      },
    },
  ];

  return (
    <Modal
      title={<></>}
      open={open}
      onCancel={onClose}
      width={'90%'}
      className="modal_cashier"
      footer={[
        <Button key={'ok'} type="primary" onClick={onClose}>
          <IntlMessage id="global.ok" />
        </Button>,
      ]}>
      <div className="sticky-header">
        <Text style={{ fontSize: 18, fontWeight: 'bold' }}>
          <IntlMessage id="global.cashier_information" />
        </Text>
        <br />
        <Space direction="vertical" size={[0, 0]} style={{ marginBottom: 20 }}>
          <div>
            Caissier:{' '}
            {item?.userOperator?.user?.firstname +
              ' ' +
              item?.userOperator?.user?.lastname}
          </div>
          <div>Téléphone: {item?.userOperator?.user?.mobile}</div>
          <div>
            Caisse:{' '}
            <span style={{ color: 'red' }}>
              {formatCurrency(item?.total_paid_detail || 0)}
            </span>
          </div>
        </Space>

        <Row justify={'start'}>
          <Col>
            <Row>
              <Form form={form} onFinish={onSearchDate}>
                <Row justify={'start'}>
                  {/* <Col>
                  <Radio.Group
                    name="date_type"
                    onChange={(e) =>
                      onFilter(e.target.value, e.target.name, '')
                    }
                    defaultValue={dataDateType[0].value}>
                    <Flex vertical>
                      {dataDateType?.map((item, index) => {
                        return (
                          <Radio key={index} value={item?.value}>
                            {item?.label}
                          </Radio>
                        );
                      })}
                    </Flex>
                  </Radio.Group>
                </Col> */}
                  <Col>
                    <Form.Item
                      name={'mode'}
                      initialValue={'date'}
                      rules={[
                        {
                          required: true,
                          message: <IntlMessage id="global.requiredfeild" />,
                        },
                      ]}>
                      <Select
                        placeholder="Select mode"
                        onSelect={onChangeMode}
                        options={[
                          {
                            value: 'date',
                            label: <IntlMessage id="global.date" />,
                          },
                          {
                            value: 'month',
                            label: <IntlMessage id="global.month" />,
                          },
                          {
                            value: 'day',
                            label: <IntlMessage id="global.day" />,
                          },
                        ]}></Select>
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item
                      name="from_date"
                      // initialValue={dayjs().startOf('M')}
                      dependencies={['mode', 'to_date']}
                      rules={[
                        {
                          required: false,
                          message: <IntlMessage id="global.requiredfeild" />,
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (getFieldValue('mode')) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error('Please select mode!!')
                            );
                          },
                        }),
                      ]}>
                      <DatePicker
                        className="date_cashier"
                        placeholder={mode === 'month' ? 'Mois' : 'Date'}
                        format={mode === 'month' ? 'MM-YYYY' : 'DD-MM-YYYY'}
                        picker={mode}
                      />
                    </Form.Item>
                  </Col>
                  {mode === 'date' && (
                    <Col>
                      <Form.Item
                        name="to_date"
                        // initialValue={dayjs().endOf('M')}
                        dependencies={['mode', 'from_date']}
                        rules={[
                          {
                            required: false,
                            message: <IntlMessage id="global.requiredfeild" />,
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                (value && getFieldValue('from_date')) ||
                                !getFieldValue('from_date')
                              ) {
                                return Promise.resolve();
                              }

                              return Promise.reject(
                                new Error('Please select from date!!')
                              );
                            },
                          }),
                        ]}>
                        <DatePicker
                          className="date_cashier"
                          placeholder="Date"
                          format={'DD-MM-YYYY'}
                          picker={mode}
                        />
                      </Form.Item>
                    </Col>
                  )}
                  <Col>
                    <Form.Item>
                      <Button type="primary" htmlType="submit">
                        Filtrer
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Row>
          </Col>
        </Row>
        {filter.from_date && filter.to_date && !loading && (
          <Row justify={'center'}>
            <Space
              direction="vertical"
              align="center"
              size={[0, 0]}
              style={{ marginBottom: 20 }}>
              <Text style={{ fontSize: 18, textAlign: 'center' }}>Versé</Text>

              <div style={{ fontWeight: '600' }}>
                {formatCurrency(totalPaid).replace('CFA', '')} F CFA
              </div>
            </Space>
          </Row>
        )}
      </div>
      <Table
        dataSource={items}
        columns={columns}
        tableLayout="auto"
        loading={loading}
        bordered
        scroll={{ x: 'max-content', y: 500 }}
        rowKey="id"
        size="small"
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50'],
          total: total,
          current: filter.page,
          pageSize: filter.limit,
        }}
        onChange={onChangeTable}
      />
      {modalInfo && (
        <ModalInfoDetail
          open={modalInfo}
          onClose={onCloseModalInfo}
          item={ItemInfo}
        />
      )}
    </Modal>
  );
};

export default ModalOrder;
